var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModelWithBadge = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M8.5 1.423a1 1 0 0 0-1 0L2.554 4.279a1 1 0 0 0-.5.866v5.711a1 1 0 0 0 .5.866L7.5 14.578a1 1 0 0 0 1 0l.222-.129A4.232 4.232 0 0 1 8.25 12.5c0-.724.18-1.405.5-2.002V8.425l3.696-2.218V8.25h.054c.508 0 .995.089 1.446.252V5.145a1 1 0 0 0-.5-.866L8.5 1.423ZM3.554 6.207v4.36l3.696 2.134V8.425L3.554 6.207Zm8.064-1.252L8 2.866 4.382 4.955 8 7.125l3.618-2.17Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M9.75 11c0 .156.029.306.081.444a1.25 1.25 0 0 0 0 2.112 1.25 1.25 0 0 0 1.613 1.613 1.25 1.25 0 0 0 2.112 0 1.25 1.25 0 0 0 1.613-1.613 1.25 1.25 0 0 0 0-2.112 1.25 1.25 0 0 0-1.613-1.613 1.25 1.25 0 0 0-2.112 0A1.25 1.25 0 0 0 9.75 11Zm1.533 1.217.717.717 1.717-1.717a.4.4 0 1 1 .566.566l-2 2a.4.4 0 0 1-.566 0l-1-1a.4.4 0 1 1 .566-.566Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgModelWithBadge);
export default ForwardRef;